import graphqlClient from '~/graphql/graphqlClient';
import type {
  MutationPlaceItemInGlobalInventoryArgs,
  ItemMoveResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation PlaceItemInGlobalInventory(
  $playerId: String!
  $itemId: String!
  $from: ItemLocationInput!
  $to: ItemLocationInput!
) {
  placeItemInGlobalInventory(
    playerId: $playerId
    itemId: $itemId
    from: $from
    to: $to
  ) {
    inventory
    heroRoster
  }
}
`;

export default async function mutationPlaceItemInGlobalInventory(
  args: MutationPlaceItemInGlobalInventoryArgs
): Promise<ItemMoveResult> {
  return await graphqlClient.request<ItemMoveResult>('placeItemInGlobalInventory', mutation, args);
}
